export default __webpack_public_path__ + "static/N0068-1f2ba04521195f5dc10ff7e88385e1f0.png";